<template>
  <AthleteField :label="label" class="w-24 text-left">
    <div class="flex flex-row">
      <p class="m-0 font-medium text-gray-900 ds-text-4xl">{{ value }}</p>
      <div
        class="relative flex flex-col items-start justify-center w-full pl-1"
      >
        <component :is="iconComponent" class="aw-auto" height="30px" />
      </div>
    </div>
  </AthleteField>
</template>

<script>
import AthleteField from "../../AthleteField.vue";
export default {
  components: {
    AthleteField,
  },
  props: {
    iconComponent: { required: true },
    label: { type: String, required: true },
    value: { type: String, required: true },
  },
};
</script>
